import { IAm } from '@shared/types';
import { AUTH_LOCAL_TOKEN_UPDATED, SET_USER } from '../actions/types';

type AuthAction =
    | { type: typeof AUTH_LOCAL_TOKEN_UPDATED; payload: { token: string } }
    | { type: typeof SET_USER; payload: IAm };

const DEFAULT_IAM = { authenticated: false } as const;

type AuthState = {
    isLoading: boolean;
    iam: IAm;
};

const initialState: AuthState = {
    isLoading: true,
    iam: DEFAULT_IAM,
};

export default function auth(state = initialState, action: AuthAction) {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                isLoading: false,
                iam: action.payload,
            };
        default:
            return state;
    }
}
